export function formateraDatumOchTid(date: Date) {
  const formatted = date.toLocaleString('sv-SE', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return formatted.substring(0, 10) + ' ' + formatted.substring(11, 16);
};

export function formatDateToDateString(date: Date, options?: Intl.DateTimeFormatOptions): string {
  const defaultOption: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };
  return new Date(date).toLocaleDateString(navigator.language, { ...defaultOption, ...options });
};
